import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.split";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import { ColorModeProvider } from '@xstyled/styled-components';
import { ThemeProvider } from './ThemeProvider';
import { GlobalStyle } from './GlobalStyle';
import { Code } from './Code';
var components = {
  code: function code(_ref) {
    var children = _ref.children,
        className = _ref.className,
        props = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

    var lang = className && className.split('-')[1];
    return React.createElement(Code, Object.assign({
      lang: lang
    }, props), children);
  }
};
export function RootWrapper(_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme;
  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(ColorModeProvider, null, React.createElement(MDXProvider, {
    components: components
  }, React.createElement(React.Fragment, null, React.createElement(GlobalStyle, null), children))));
}